import { faPhoneAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  getAvailibilityApi,
  getDeliveryInfoApi,
  logOutApi,
  sendAvailibilityPostApi,
} from "../../Api/DeliveryBarest";
import BottomNavigation from "../../Components/BottomNavigation/BottomNavigation";
import Button from "../../Components/Button/Button";
import LoadingComponet from "../../Components/LoadingComponet/LoadingComponet";
import MenuTitle from "../../Components/MenuTitlle/MenuTitle";
import { errorToast, succToast } from "../../Utils/Toast/Toast";
import Style from "./Profile.module.css";
import { useHistory } from "react-router-dom";
const Profile = () => {
  const [data, setData] = useState();
  const [openApi, setOpenApi] = useState();
  const [disable, setDisable] = useState();
  // const [open, setOpen] = useState(openApi);
  useEffect(() => {
    getProfileInfo();
    getHourWork();
  }, []);
  const history = useHistory();
  const getProfileInfo = async () => {
    getDeliveryInfoApi((succ, res) => {
      if (succ) {
        if (res.status === -2) {
          localStorage.clear();
          logout();
          history.push("/login");
          setTimeout(() => {
            window.location.reload();
          }, 100);
        }
        if (res.status === 0) {
          errorToast("مشکلی پیش آمده است");
        } else {
          setData(res.deliver);
        }
      } else {
        errorToast("خطایی در سرور رخ داده است");
      }
    });
  };
  /////////گرفتن ساعت کاری پیک
  const getHourWork = async () => {
    const result = await getAvailibilityApi();
    setOpenApi(result.availability === "1");
  };

  /////برای قسمت باز و بسته
  const openHandler = () => {
    setOpenApi(!openApi);
    const info = {
      availability: openApi ? "0" : "1",
      start_1: [
        "00:00:00",
        "00:00:00",
        "00:00:00",
        "00:00:00",
        "00:00:00",
        "00:00:00",
        "00:00:00",
      ],
      end_1: [
        "00:00:00",
        "00:00:00",
        "00:00:00",
        "00:00:00",
        "00:00:00",
        "00:00:00",
        "00:00:00",
      ],
      start_2: [
        "00:00:00",
        "00:00:00",
        "00:00:00",
        "00:00:00",
        "00:00:00",
        "00:00:00",
        "00:00:00",
      ],
      end_2: [
        "00:00:00",
        "00:00:00",
        "00:00:00",
        "00:00:00",
        "00:00:00",
        "00:00:00",
        "00:00:00",
      ],
    };
    sendAvailibilityPostApi(info, (res) => {
      if (res.status === 1) {
        succToast("بروز رسانی شد");
      } else {
        errorToast("دوباره امتحان کنید");
      }
    });
  };
  const isLogin = () => !!localStorage.getItem("JwtTokens");
  const logout = () => {
    setDisable(true);
    let info = {
      logout: "",
    };
    logOutApi(info, (succ) => {
      if (isLogin()) {
        if (succ.status === 1) {
          setDisable(false);
          localStorage.clear();
          errorToast("خارج شدین");
          window.location.reload();
        } else {
          setDisable(false);
          errorToast("خطایی رخ داده");
        }
      } else {
        errorToast("شما هنوز وارد نشدید!!");
      }
    });
  };
  let loading = null;
  if (data === undefined) {
    loading = <LoadingComponet />;
  } else {
    loading = (
      <div className={Style.center}>
        <section className={Style.personInfo}>
          <div className={Style.imgHolder}>
            <img
              src={`http://cdn.barest.ir/deliver/photo/${data.photo}.jpg`}
              alt="barest"
            />
          </div>
          <div className={Style.info}>
            <h2 className={Style.name}>
              {data.first_name} {data.last_name}
            </h2>
            <p className={Style.phone}>{data.phone}</p>
            <a href="tel:09114555773" className={Style.support}>
              تماس با پشتیبانی{" "}
              <FontAwesomeIcon className={Style.icon} icon={faPhoneAlt} />
            </a>
            <Link to={"/کیف_پول"} className={Style.wallet}>
              کیف پول
            </Link>
            <div className={Style.Condition}>
              <div
                onClick={openHandler}
                style={{ borderRadius: ".3rem 0  0 .3rem ", cursor: "pointer" }}
                className={openApi ? Style.true : Style.false}
              >
                آنلاین
              </div>
              <div
                onClick={openHandler}
                style={{ borderRadius: "0 .3rem .3rem 0 ", cursor: "pointer" }}
                className={openApi ? Style.false : Style.true}
              >
                آفلاین
              </div>
            </div>
          </div>
          <div className={Style.statistics}>
            <h3 className={Style.title}>
              آمار {data.role === "driver" ? "سفر" : "تحویل"}
            </h3>
            <h4 className={Style.delivryCount}>
              :تعداد {data.role === "driver" ? "سفرهای" : "تحویل داده شده"}{" "}
              روزانه <span className={Style.count}>{data.today}</span>
            </h4>
            <h4 className={Style.delivryCount}>
              :تعداد {data.role === "driver" ? "سفرهای" : "تحویل داده شده"}{" "}
              هفتگی <span className={Style.count}>{data.week}</span>
            </h4>
            <h4 className={Style.delivryCount}>
              :تعداد {data.role === "driver" ? "سفرهای" : "تحویل داده شده"}{" "}
              ماهانه <span className={Style.count}>{data.month}</span>
            </h4>
            <h4 className={Style.delivryCount}>
              :تعداد {data.role === "driver" ? "سفرهای" : "تحویل داده شده"} کل{" "}
              <span className={Style.count}>{data.total}</span>
            </h4>
          </div>
          <Link to={"/support"} className={Style.supportLinkHolder}>
            درخواست پشتیبانی
          </Link>
          <div className={Style.btnHolder}>
            <Button
              Value="خروج"
              ClassBtn={"confirmBtn"}
              ClickHandler={logout}
              disabledProps={disable}
            />
          </div>
        </section>
      </div>
    );
  }
  return (
    <div className={Style.pageHolder}>
      <MenuTitle title="پروفایل" />
      {loading}
      <BottomNavigation />
    </div>
  );
};

export default Profile;
